<template>
  <div id="overlay">
    <div class="overlay-inner">
      <p @click="close" class="close icon"><close-svg></close-svg></p>
      <div @click="getPrev" class="prev-arrow icon"><arrow-svg/></div>
      <img :src="image">
      <div @click="getNext" class="next-arrow icon"><arrow-svg/></div>
    </div>
  </div>
</template>

<script>
  import ArrowSvg from './arrow'
  import CloseSvg from './close'

  export default {
    name: 'companyGalleryPopup',
    components: {CloseSvg, ArrowSvg},
    props: ['image'],
    methods: {
      close () {
        this.$emit('close')
      },
      getPrev () {
        this.$emit('prev')
      },
      getNext () {
        this.$emit('next')
      }
    }
  }
</script>

<style scoped>
  #overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    padding: 40px;
    top: 0;
    left: 0;
    color: #fff;
    z-index: 100;
    background-color: rgba(40, 70, 120, 0.9);
    box-sizing: border-box;
  }

  .overlay-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .icon {
    width: 40px;
    height: 40px;
    padding: 10px;
    color: #fff;
    border: 1px solid #fff;
    box-sizing: border-box;
  }

  .prev-arrow {
    transform: rotate(90deg);
  }

  .next-arrow {
    transform: rotate(-90deg);
  }

  .close {
    position: absolute;
    top: 20px;
    right: 40px;
  }
</style>
